module.exports = __webpack_public_path__ + "static/media/search_iteration_pain_points.f06b72c0.png";